export default __webpack_public_path__ + "static/media/warning-icon.092616e7.svg";